import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    email: string;
    password: string;
    rememberMe = true;

    error: string;
    isLoading = false;

    constructor(private authService: AuthService, private router: Router) { }

    ngOnInit() {
        if (this.authService.isLoggedIn()) {
            this.router.navigate(['admin']);
        }
    }

    async login(provider = 'email') {
        if (this.isLoading) return;

        this.error = null;
        this.isLoading = true;
        try {
            switch (provider) {
                case 'email':
                    await this.authService.login(this.email, this.password);
                    break;
                // case 'google':
                //     await this.authService.signInWithGoogle();
                //     break;
                // case 'facebook':
                //     await this.authService.signInWithFB();
                //     break;
            }
            await this.router.navigate(['admin']);
        } catch (e) {
            this.error = "Username sau parola incorecta.";
        } finally {
            this.isLoading = false;
        }
    }

}
